/* Uses the product's existing form so variants, quantity and cart behavior stay shared. */
if (!customElements.get('ib-sticky-cart')) {
  customElements.define('ib-sticky-cart', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('[data-pdp]');
      this.primary = this.root?.querySelector('[data-add]');
      if (!this.primary) return;
      this.button = this.querySelector('button');
      this.price = this.root.querySelector('[data-price]');
      this.status = this.root.querySelector('[data-add-status]');
      this.header = document.querySelector('.bt-headroot');
      this.main = document.querySelector('#MainContent');
      this.drawer = document.querySelector('cart-drawer');
      this.variants = JSON.parse(this.root.querySelector('[data-variants]')?.textContent || '[]');
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
      };
      this.button.addEventListener('click', () => {
        if (this.primary.disabled) return;
        this.primary.click();
        // The native form handler runs synchronously and assigns the original button.
        this.drawer?.setActiveElement?.(this.button);
        this.sync();
      }, { signal });
      window.addEventListener('scroll', this.schedule, { passive: true, signal });
      window.addEventListener('resize', this.schedule, { passive: true, signal });
      this.root.addEventListener('change', this.schedule, { signal });
      this.observer = new MutationObserver(this.schedule);
      [this.primary, this.price, this.status].filter(Boolean).forEach(node => {
        this.observer.observe(node, { attributes: true, childList: true, subtree: true, characterData: true });
      });
      // Menus, image viewer and cart overlay always take priority over the bar.
      this.observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      if (this.drawer) this.observer.observe(this.drawer, { attributes: true, attributeFilter: ['class'] });
      this.resizeObserver = new ResizeObserver(this.schedule);
      [this.primary, this.header, this.main].filter(Boolean).forEach(node => this.resizeObserver.observe(node));
      this.update();
    }
    sync() {
      this.button.disabled = this.primary.disabled;
      this.button.textContent = this.primary.textContent.trim();
      this.button.setAttribute('aria-busy', String(this.primary.getAttribute('aria-busy') === 'true'));
      this.querySelector('[data-sticky-price]').textContent = this.price?.textContent || '';
      const variant = this.variants.find(item => String(item.id) === this.root.querySelector('[data-variant-id]')?.value);
      this.querySelector('[data-sticky-variant]').textContent = variant && variant.title !== 'Default Title' ? variant.title : '';
      const error = this.querySelector('[data-sticky-status]');
      const message = this.status && !this.status.hidden ? this.status.textContent : '';
      if (error.textContent !== message) error.textContent = message;
      error.hidden = !message;
    }
    update() {
      this.sync();
      const mobile = window.matchMedia('(max-width: 749px)').matches;
      const top = Math.max(0, this.header?.getBoundingClientRect().bottom || 0);
      this.style.setProperty('--ib-sticky-top', `${top}px`);
      // Cart drawer overlays the bar via its higher stacking layer. Keep the
      // button mounted/visible underneath so closing the drawer restores focus.
      const overlay = document.body.matches('.bt-mobile-menu-open, .bt-lb-open');
      const pastButton = this.primary.getBoundingClientRect().bottom < (mobile ? top : top + 4);
      const pastContent = this.main && this.main.getBoundingClientRect().bottom < (mobile ? window.innerHeight : top + 90);
      const hide = !pastButton || pastContent || overlay || (mobile && this.dataset.mobile === 'false');
      // Move keyboard focus back to its equivalent if scrolling hides the focused bar.
      if (hide && !overlay && this.contains(document.activeElement)) this.primary.focus({ preventScroll: true });
      this.hidden = Boolean(hide);
      document.documentElement.style.setProperty('--ib-sticky-height', `${this.hidden ? 0 : this.getBoundingClientRect().height}px`);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      document.documentElement.style.removeProperty('--ib-sticky-height');
    }
  });
}
